module.exports = __webpack_public_path__ + "img/5.fd08bb2f.jpg";